"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickerWidget = void 0;
var tslib_1 = require("tslib");
var TableauUI = tslib_1.__importStar(require("@tableau/tableau-ui"));
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var Declarative_1 = require("../../utils/Declarative");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var iconStyleName = TypeStyle.style({
    $nest: {
        '& > :first-child': tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelect), { color: 'var(--border-color)', marginRight: 4 }),
        'button&:disabled > :first-child': {
            color: 'inherit',
        },
    }
});
/**
 * Sticker is a visual marker that represents a status or classification that users add to their content.
 * May be passed as the `triggerElement` of a `PopoverWidget` to render an interactive sticker.
 * */
var StickerWidget = function (props) {
    var _a;
    var children = props.children, className = props.className, icon = props.icon, testId = props.testId, stickerProps = tslib_1.__rest(props, ["children", "className", "icon", "testId"]);
    return (React.createElement(TableauUI.Sticker, tslib_1.__assign({}, (stickerProps.onClick && ReactHelpers_1.EventUtilsOptOut), { "data-tb-test-id": Declarative_1.makeTestId(testId, 'StickerWidget') }, stickerProps, { children: React.createElement(React.Fragment, null,
            icon,
            children), className: TypeStyle.classes(className, (_a = {}, _a[iconStyleName] = !!icon, _a)) })));
};
exports.StickerWidget = StickerWidget;
exports.StickerWidget.displayName = 'StickerWidget';
//# sourceMappingURL=StickerWidget.js.map